<template>
	<div>
		<!-- Home顶部功能区域 -->
		<div class="site-nav" id="site-nav">
			<div class="w w1200">
				<ul class="quick-menu fl">
					<li>
						<div class="dt">
							<router-link to="/brand">品牌馆</router-link>
						</div>
					</li>
					<li class="spacer" v-if="showRegister"></li>
					<li v-if="showRegister">
						<div class="dt">
							<router-link to="/welcomesystem">商家入驻</router-link>
						</div>
					</li>
					<li class="spacer" v-if="copyRight.consumerHotline"></li>
					<li v-if="copyRight.consumerHotline">
						<div class="dt">
							<a href="javascript:;"><i class="el-icon-phone"></i> HELLO:{{copyRight.consumerHotline}}</a>
						</div>
					</li>
					<li class="spacer" v-if="showAppCode"></li>
					<li class="li_dorpdown">
						<div class="dt" v-if="showAppCode">
							<a href="javascript:;" @mouseenter="showapp = !showapp" @mouseleave="showapp = !showapp"><i
									class="el-icon-mobile-phone"></i> APP下载
								<i class="el-icon-arrow-down"></i></a>
						</div>
						<transition name="el-zoom-in-top">
							<div v-show="showapp" class="dropdown-menu" style="
                  z-index: 10000000;
                  position: absolute;
                  border-top: 2px solid #485577; /* 同步修改为目标色 */
                  background: #fff;
                  padding: 6px;
                ">
								<div class="qrcode" ref="qrCodeUrl"></div>
							</div>
						</transition>
					</li>
					<li class="spacer"></li>
					<li>
						<div class="dt">
							<a href="javascript:;" @mouseenter="showwx = !showwx" @mouseleave="showwx = !showwx"><i
									class="el-icon-mobile-phone"></i> 微商城
								<i class="el-icon-arrow-down"></i></a>
						</div>
						<transition name="el-zoom-in-top">
							<div v-show="showwx" class="dropdown-menu" style="
                  z-index: 10000000;
                  position: absolute;
                  border-top: 2px solid #485577; /* 同步修改为目标色 */
                ">
								<div class="qrcode" ref="qrCodeUrls"></div>
							</div>
						</transition>
					</li>
					<li class="spacer"></li>
					<li>
						<div class="amap-page-container">
							<el-amap vid="amap" :plugin="plugin" class="amap-demo" :center="center">
							</el-amap>
							<div class="toolbar">
								<span v-if="loaded" style="color: rgb(102, 102, 102); border-radius: 4px">
									<i class="el-icon-location"></i> {{ city }}
								</span>
								<span v-else>正在定位</span>
							</div>
						</div>
					</li>
				</ul>
				<ul class="quick-menu fr">
					<li>
						<div class="dt">
							<router-link to="/login" v-if="userInfo.loginName == null ? true : false">登录</router-link>
						</div>
						<el-dropdown>
							<span class="el-dropdown-link" style="cursor: pointer">
								<a v-if="userInfo.loginName == null ? false : true">{{
                  userInfo.userName||userInfo.loginName
                }}</a></span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item><a href="javaScript:;" @click="rollOut">退出</a></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</li>
					<li v-if="userInfo.loginName == null ? true : false" class="spacer"></li>
					<li>
						<div class="dt">
							<router-link to="/register"
								v-if="userInfo.loginName == null ? true : false">注册</router-link>
						</div>
					</li>
					<li class="spacer"></li>
					<li>
						<div class="dt">
							<router-link to="/myOrder">我的订单</router-link>
						</div>
					</li>
					<li class="spacer"></li>
					<li>
						<div class="dt">
							<router-link to="/goodsCollection">我的收藏</router-link>
						</div>
					</li>
					<li class="spacer"></li>
					<li>
						<el-dropdown>
							<span class="dt el-dropdown-link" style="cursor: pointer">
								客户服务</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item><router-link
										to="/siteHelp?articleId=1">帮助中心</router-link></el-dropdown-item>
								<el-dropdown-item><router-link
										to="/siteHelp?articleId=5&categoryId=5">售后服务</router-link></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</li>
					<li class="spacer"></li>
					<li>
						<el-dropdown>
							<span class="dt el-dropdown-link" style="cursor: pointer">
								站点导航</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item><router-link
										to="/siteNavigation">用户中心</router-link></el-dropdown-item>
								<el-dropdown-item><router-link to="/paymentCenter">支付中心</router-link></el-dropdown-item>
								<el-dropdown-item><router-link to="/">网站首页</router-link></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</li>
					<li>
						<el-dropdown>
							<span class="dt el-dropdown-link" style="cursor: pointer; color: #485577;"> <!-- 技术/预算文字色修改 -->
								技术/预算</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item><router-link
										to="/ConsultationComplaints/?type=技术服务">技术服务</router-link></el-dropdown-item>
								<el-dropdown-item><router-link to="/ConsultationComplaints/?type=预算服务">预算服务</router-link></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						</li>
				</ul>
			</div>
		</div>
		<!-- logo+搜索 -->
		<div class="w w1200">
			<el-row class="logotop " type="flex" justify="center" align="top">
				<el-col :span="6">
					<div class="fl">
						<el-image @click="$router.push('/')" class="logo" style="cursor: pointer" :src="logo"
							fit="fill">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>
						<!-- <el-image v-if="showRegister" :src="require('@/assets/images/ecsc-join.gif')" fit="fill"
							class="rzIcon" @click="goTheStore()" style="border-radius: 5px">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image> -->
					</div>
				</el-col>
				<el-col :span="10">
					<!-- 搜索框容器 -->
					<div class="grid-content bg-purple">
						<!-- 1. 核心修改：输入框边框色改为 #485577 -->
						<el-input :placeholder="hotSearchList[0]" v-model="searchInput"
							@keyup.enter.native="getSearchClick('')" class="input-with-select"
							style="border: 4px solid #485577;"> <!-- 原 #e3550d 改为目标色 -->
							<!-- 2. 搜索按钮背景色改为 #485577 -->
							<el-button slot="append" icon="el-icon-search" style="font-size: 22px; z-index: 10000;"
								id="seekBtn" @click="getSearchClick('')"></el-button>
						</el-input>
					</div>
					<div style="margin-top: 5px; text-align: left">
						<span v-for="(item, index) in hotSearchList" :key="index">
							<span @click="getSearchClick(item)">{{item}}</span>
							<el-divider direction="vertical"></el-divider>
						</span>
					</div>
				</el-col>
        	<div class="fl" style="margin-left: 55px;">
        	  <el-image v-if="showRegister" :src="require('@/assets/images/ecsc-join.gif')" fit="fill"
        	    class="rzIcon"  @click="goTheStore()" style="border-radius: 5px">
        	    <div slot="error" class="image-slot">
        	      <i class="el-icon-picture-outline"></i>
        	    </div>
        	  </el-image>
        	</div>
				<el-col :span="6" style="text-align: right">
					<div class="grid-content bg-purple">
						<el-popover placement="top-start" width="400" trigger="click">
							<div class="cartTip">
								<el-row :gutter="20" class="cartBox" v-for="(item, index) in list" :key="index">
									<el-col :span="5"><el-image class="cartgoodsPhotos"
											:src="`${item.photos}`"></el-image></el-col>
									<el-col :span="12">
										<div class="cartHeight" title="">
											{{ item.name }}
										</div>
									</el-col>
									<el-col :span="6">
										<div class="cartHeight">
											{{ item.realprice }} * {{ item.number }}
										</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24" v-if="totalNumber == 0 ? true : false">购物车还没有商品,赶紧选购吧!</el-col>
								</el-row>
								<el-row class="cartBox_footer">
									<el-col :span="12">
										<div class="cartHeight_total">
											<p class="totalNum">共 {{ totalNumber || 0 }} 件商品</p>
											<p>{{ accountTotal.toFixed(2) || 0 }} 元</p>
										</div>
									</el-col>
									<el-col :span="12">
										<div class="cartHeight_cart">
											<router-link to="/shoppingcart" style="color: white">去购物车结算</router-link>
										</div>
									</el-col>
								</el-row>
							</div>
							<el-button slot="reference" class="shopgoods"><i class="el-icon-shopping-cart-full"></i> 购物车
								({{ totalNumber }})
							</el-button>
						</el-popover>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 顶部菜单 -->
		<div class="w w1200" v-if="isShowNav">
			<div class="categorys">
				<div class="categorys-type" @mouseenter="mouseenterBox" @mouseleave="mouseLeaveBox">
					<a href="javascript:;"><i class="el-icon-menu"></i> 全部商品分类</a>
				</div>
				<!-- 隐藏分类 -->
				<div class="categorys-tab-content" v-show='isShowCategoryList' @mouseleave="mouseLeaveBox">
					<div class="categorys-items " id="cata-nav">
						<!-- 商品分类start -->
						<div class="categorys-item" v-for="(oneItem, index) in categoryList" :key="index + '_item'">
							<div class="item item-content">
								<i class="iconfont icon-ele"><img :src="oneItem.categoryOne.icon"
										style="vertical-align: baseline"
										/></i>
								<div class="categorys-title">
									<strong>
										<router-link
											:to="`/goodsList?parentBxscId=${oneItem.categoryOne.bxscId}&secondCategory=true`">{{ oneItem.categoryOne.name }}</router-link>
									</strong>
									<span>
										<router-link
											:to="`/goodsList?parentBxscId=${subItems.category.bxscId}&secondCategory=true`"
											v-for="(subItems, index) in oneItem.subItems.slice(0, 2)"
											:key="index + '_sub'"><template>{{
                        subItems.category.name
                      }}</template></router-link>
									</span>
								</div>
							</div>
							<div class="categorys-items-layer categorys-items-second-layer">
								<div class="cate-layer-con clearfix">
									<!-- 展示二级分类 -->
									<div class="cate-layer-second" v-if="!showThreeClass">
										<div class="cateChanneSecond" v-for="(subItem, index) in oneItem.subItems"
											:key="index + 'sunItem'">
											<el-image
												:src="subItem.category.icon?subItem.category.icon:'http://xyss.com.cn/no.png'"
												fit="fill">
												<div slot="error" class="image-slot">
													<i class="el-icon-picture-outline"></i>
												</div>
											</el-image>
											<router-link class="cateChanneSecondName"
												:to="`/goodsList?parentBxscId=${subItem.category.bxscId}&secondCategory=true`">{{ subItem.category.name }}</router-link>
										</div>
									</div>
									<!-- 展示三级 分类 -->
									<div class="cate-layer-left" v-if="showThreeClass">
										<div class="cate_channel">
											<router-link
												:to="`/goodsList?parentBxscId=${subItem.category.bxscId}&secondCategory=true`"
												v-for="(subItem, index) in oneItem.subItems.slice(0, 6)"
												:key="index + 'sunItem'">{{ subItem.category.name }}</router-link>
										</div>
										<div class="cate_detail">
											<dl v-for="(subItem, index) in oneItem.subItems" :key="index + 'sunItem'"
												:class="'dl_fore' + (index + 1)">
												<dt>
													<router-link
														:to="`/goodsList?parentBxscId=${subItem.category.bxscId}&secondCategory=true`">{{ subItem.category.name }}</router-link>
												</dt>
												<dd>
													<router-link
														:to="`/goodsList?parentBxscId=${thrItem.bxscId}&secondCategory=true`"
														v-for="(thrItem, index) in subItem.sub"
														:key="index + '_thr'">{{ thrItem.name }}</router-link>
												</dd>
											</dl>
										</div>
									</div>
									<div v-if="oneItem.subItems.length == 0 ? true : false" class="nodataCss">
										<p>暂无相关分类数据</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="nav-main">
				<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router
					@select="handleSelect">
					<template v-for="(item, index) in navList">
						<el-menu-item :index="item.navUrl" :key="index + '_nav'"
							v-if="userInfo.type != 1 && item.navTitle == '批发市场'? false: true && item.navTitle == '商家店铺' ? false: true"
							:class="item.navTitle == '我的询价'?'signEnquiry':''">
							<i>{{ item.navTitle }}</i>
						</el-menu-item>
					</template>
					<template v-for="(item1, index) in navList">
						<el-menu-item index="" :key="index + '_nav1'"
							v-if="item1.navTitle === '商家店铺' && userInfo.type != 0&& userInfo.type != 2? true: false">
							<a :href="item1.navTitle === '商家店铺' && userInfo.type&&userInfo.type!= 0?`${$baseUrl}${item1.navUrl}`:'#/login'"
								target="_blank"><i>{{ item1.navTitle }}</i></a>
						</el-menu-item>
					</template>
				</el-menu>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript" src="../assets/js/kuCity.js"></script>
<script>
	import { menu } from "../api/userMG";
	import mainlayout from "../components/layout/mainlayout";
	import {
		navList, leftMenuList, shoppingCartlist, hot_search, search_list,
		setImage, systemConfig, apiConfig, apiHelpArticle, getenquiryNum
	} from "@/api/xunyou";
	import { mapState, mapMutations } from "vuex";
	import QRCode from 'qrcodejs2'
	import bus from "@/utils/bus";
	export default {
		name: "leftnav",
		inject: ["reload"],
		data() {
			let self = this;
			return {
				loading: false,
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				showapp: false,
				appimg: "https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200806/1596701627449534.png",
				showwx: false,
				show2: false,
				collapsed: false,
				allmenu: [],
				center: [121.59996, 31.197646],
				city: "全国",
				lng: 0,
				lat: 0,
				loaded: false,
				logo: "",
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				plugin: [{
					pName: "Geolocation",
					events: {
						init(o) {
							o.getCurrentPosition((status, result) => {
								if (result && result.position) {
									self.$store.commit(
										"gotCurrentAddress",
										result.addressComponent
									);
									console.log(result, "|wb");
									self.lng = result.position.lng;
									self.lat = result.position.lat;
									self.city =
										result.addressComponent.city ||
										result.addressComponent.district;
									self.center = [self.lng, self.lat];
									self.loaded = true;
									self.$nextTick();
								}
							});
						},
					},
				}, ],
				navList: [],
				activeIndex: "1",
				categoryList: [],
				hotSearchList: [],
				searchInput: "",
				isShowCategoryList: false,
				appUrl: '',
				appUrl: '',
				showThreeClass: false,
				helpArticle: [],
				showAppCode: false,
				showRegister: true,
				cityData: {}
			};
		},
		components: { mainlayout },
		computed: {
			...mapState(["isShowNav", "list", "accountTotal", "totalNumber", 'copyRight']),
		},
		watch: {},
		mounted() {
			this.cityData = JSON.parse(localStorage.getItem('cityInfo'));
			this.city = this.cityData.cname;
			if (this.city) {
				this.loaded = true
			}
			this.getSystemConfig()
			this.gethotSearch();
			this.getImagelogo();
			this.getshoppingCartlist();
			this.getApiConfig()
			this.getTopApiConfig('appDownload')
			this.getTopApiConfig('merchantSettled')
			this.getApiHelpArticle()
		},
		methods: {
			creatQrCode() {
				var qrcode = new QRCode(this.$refs.qrCodeUrl, {
					text: this.appUrl,
					width: 100,
					height: 100,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			},
			creatH5QrCode() {
				var qrcode = new QRCode(this.$refs.qrCodeUrls, {
					text: this.H5Url,
					width: 100,
					height: 100,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			},
			getSystemConfig() {
				systemConfig()
					.then((res) => {
						if (res.code == 0) {
							res.rows.forEach(element => {
								if (element.configKey == 'appUrl') {
									this.appUrl = element.configValue
								}
								if (element.configKey == 'H5Url') {
									this.H5Url = element.configValue
								}
							});
							this.creatQrCode();
							this.creatH5QrCode()
						}
					})
			},
			getTopApiConfig(key) {
				apiConfig({ key: key })
					.then((res) => {
						if (res.code == 0) {
							if (res.rows.length > 0) {
								if (key == 'merchantSettled') {
									this.showRegister = res.rows[0].configValue == 1 ? true : false
								} else {
									this.showAppCode = res.rows[0].configValue == 1 ? true : false
								}
							}
						}
					})
			},
			getApiConfig() {
				apiConfig({ key: 'show_three_class' })
					.then((res) => {
						if (res.code == 0) {
							if (res.rows.length > 0) {
								this.showThreeClass = res.rows[0].configValue == 1 ? true : false
							}
						}
					})
			},
			getApiHelpArticle() {
				apiHelpArticle()
					.then((res) => {
						if (res.code == 0) {
							if (res.data.length > 0) {
								this.helpArticle = res.data || []
							}
						}
					})
			},
			getshoppingCartlist() {
				shoppingCartlist({ uid: this.userInfo.userId || "" })
					.then((res) => {
						if (res.length > 0) {
							this.$store.commit("getCartList", res);
						}
					})
					.catch((err) => {
						this.$message.error("购物车查询失败，请稍后再试！");
					});
			},
			getSearchClick(name) {
				let path = this.$route.path;
				let val = ''
				if (name) {
					val = name
					this.searchInput = name
				} else {
					val = this.searchInput == "" ? this.hotSearchList[0] : this.searchInput;
				}
				if (!this.searchInput) {
					this.searchInput = this.hotSearchList[0];
				}
				if (path.includes('supplier')) {
					this.$router.push(`/goodsList_supplier?adWord=${val}`);
				} else {
					if (path != "/goodsList") {
						this.$router.push(`/goodsList?adWord=${val}`);
						return
					} else {
						let query = JSON.parse(JSON.stringify(this.$route.query));
						query.adWord = val;
						this.$router.replace({ query });
						bus.$emit("search", val);
					}
				}
			},
			goTheStore() {
				this.$router.push(`/welcomesystem`);
			},
			getImagelogo() {
				setImage().then((res) => {
					if (res.code == 0) {
						this.logo = res.rows[0].pcLogo;
					}
				});
			},
			mouseenterBox() {
				this.isShowCategoryList = !this.isShowCategoryList;
			},
			mouseLeaveBox() {
				this.isShowCategoryList = !this.isShowCategoryList;
			},
			rollOut() {
				localStorage.removeItem("userdata");
				this.$router.push("/login");
				window.location.reload();
			},
			searchNavList() {
				this.loading = true;
				navList()
					.then((res) => {
						if (res.code == 0) {
							this.loading = false;
							this.navList = res.data;
							this.enquiryNum()
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
						this.$message.error("加载失败，请稍后再试！");
					});
			},
			searchleftMenuList() {
				this.loading = true;
				leftMenuList()
					.then((res) => {
						if (res.code == 0) {
							this.loading = false;
							console.log(res.data);
							this.categoryList = res.data.slice(0, 10);
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
						this.$message.error("加载失败，请稍后再试！");
					});
			},
			handleSelect(key, keyPath) {},
			gethotSearch() {
				hot_search()
					.then((res) => {
						if (res.code == 0) {
							this.hotSearchList = res.data.column10.split(",");
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					})
					.catch((err) => {
						this.$message.error("加载失败，请稍后再试！");
					});
			},
			getSearchList() {
				search_list()
					.then((res) => {
						if (res.code == 0) {
							this.searchInput = res.rows[0].column1;
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					})
					.catch((err) => {
						this.$message.error("加载失败，请稍后再试！");
					});
				userId
			},
			enquiryNum() {
				console.log('数量');
				this.loading = true;
				let userId = this.userInfo.userId || '';

				getenquiryNum({ userId: userId })
					.then((res) => {
						console.log('数量2');
						var dom = document.querySelector('.signEnquiry');
						console.log(dom);
						var numBox = document.createElement("p");
						// 询价数字背景色同步修改
						numBox.style =
							"display:inline-block;;background: #485577 ;color:#fff;line-height: 23px;font-size: 12px;padding: 0 3px;border-radius: 16px;position: relative;left: 0px;top: -8px;min-width:16px;";
						var str = document.createTextNode(res.data);
						numBox.appendChild(str);
						if (res.data > 0) {
							dom.appendChild(numBox);
						}
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
					});
			},
		},
		created() {
			this.searchNavList();
			this.searchleftMenuList();
			console.log('定位');
			console.log(navigator.geolocation);
			if (navigator.geolocation) {
				var id = navigator.geolocation.watchPosition(function (position) {
					console.log("纬度" + position.coords.latitude + "经度" + position.coords.longitude)
				}, function (err) {
					switch (err.code) {
						case err.PERMISSION_DENIED:
							return "PERMISSION_DENIED";
						case err.POSITION_UNAVAILABLE:
							return "POSITION_UNAVAILABLE";
						case err.TIMEOUT:
							return "TIMEOUT";
						default:
							return "UNKNOWN_ERROR";
					}
				})
			} else {
				console.log("你的浏览器不支持geolocation");
			}
		},
	};
</script>
<style lang="less" scoped>
	/deep/ .logo img {
		width: 255px;
		height: 52px;
	}

	.logotop {
		margin: 1rem 0;
	}

	/* 3. 搜索按钮父容器背景色修改 */
	.el-input-group__append {
		border-left: 0;
		background-color: #485577; /* 原 #e13c41 改为目标色 */
	}

	.el-input-group__append,
	.el-input-group__prepend {
		background-color: #485577; /* 原 #e13c41 改为目标色 */
		color: white;
		vertical-align: middle;
		display: table-cell;
		position: relative;
		border: 0px;
		border-radius: 4px;
		padding: 0 20px;
		width: 1px;
		white-space: nowrap;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	/* 购物车按钮hover色同步修改 */
	button.el-button.shopgoods.el-button--default.el-popover__reference:hover {
		border: 1px solid #485577; /* 原 #e3550d 改为目标色 */
		color: #485577; /* 原 #e3550d 改为目标色 */
		background: #fff;
	}

	/* top菜单 */
	.categorys {
		float: left;
		width: 232px;
		height: 40px;
		position: relative;
	}

	.categorys-type {
		background-color: #485577;
		text-align: center;
		font-size: 0;
		line-height: 40px;
	}

	.categorys-type a {
		font-size: 16px;
		font-weight: 700;
		color: #fff;
		display: block;
	}

	.categorys-tab-content .selected .item-content {
		background-color: #485577 !important;
	}

	.categorys-tab-content .categorys-title span a:hover,
	.categorys-tab-content .categorys-title strong a:hover {
		color: #485577 !important;
	}

	.nav-main {
		float: left;
		width: 968px;
		overflow: hidden;
		height: 40px;
		line-height: 40px;
	}

	.el-menu--horizontal>.el-menu-item {
		float: left;
		height: 40px;
		line-height: 40px;
		margin: 0;
		border-bottom: 2px solid transparent;
		color: #909399;
	}

	/deep/.el-menu--horizontal>.el-menu-item.is-active {
		color: #485577 !important; /* 原 #ff6700 改为目标色 */
		font-weight: bold;
	}

	/* 分类表 */
	.categorys-tab-content {
		height: auto !important;
		padding: 15px 0;
		box-sizing: border-box;
		z-index: 30;
		background-color: #000;
		background-color: rgba(0, 0, 0, 0.6);
		display: block;
		position: relative;
	}

	.categorys-tab-content .categorys-items {
		position: relative;
		height: 100%;
	}

	.categorys-tab-content .categorys-item {
		cursor: pointer;
		height: 14.29%;
	}

	.categorys-tab-content .item-content {
		padding: 5px 16px;
		float: left;
		width: 200px;
		display: flex;
	}

	.categorys-tab-content .item-content .icon-other {
		float: left;
		width: 18px;
		height: 18px;
	}

	.categorys-tab-content .item-content .icon-other img {
		width: 100%;
	}

	.categorys-tab-content .iconfont {
		float: left;
		color: #bfbfbf;
	}

	.categorys-tab-content .categorys-title {
		float: left;
		margin-left: 10px;
		text-align: left;
	}

	.categorys-tab-content .categorys-title strong {
		display: block;
		font-weight: normal;
	}

	.categorys-tab-content .categorys-title strong a {
		color: #fff;
		font-size: 14px;
	}

	.categorys-tab-content .categorys-title span {
		display: block;
		font-size: 0;
	}

	.categorys-tab-content .categorys-title span a {
		color: #bfbfbf;
		margin-right: 10px;
		font-size: 14px;
	}

	.categorys-items-layer {
		display: none;
		position: absolute;
		top: 0;
		left: 232px;
		width: 966px;
		min-height: 498px;
		border: 1px solid #fff;
		background-color: #fff;
		box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.1);
		-webkit-transition: top 0.25s ease;
		transition: top 0.25s ease;

		.nodataCss {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 14px;
		}

		.cate-layer-second {
			display: flex;
			flex-flow: wrap;

			.cateChanneSecond {
				margin: 10px;

				/deep/.el-image {
					width: 80px !important;
					height: 80px !important;
				}

				.cateChanneSecondName {
					display: block;
				}
			}
		}
	}

	.categorys-items-second-layer {
		min-height: 415px;
	}

	/* 购物车的样式 */
	.cartTip {
		.cartBox.el-row {
			margin: 15px;
			height: 80px;

			.el-image.cartgoodsPhotos {
				height: 80px;
				width: 100%;
				position: inherit;
			}

			.cartHeight {
				height: 80px;
				line-height: 80px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}

		.cartHeight_total {
			font-size: 18px;
			padding: 0 20px;
			color: #485577; /* 购物车总价文字色修改 */

			.totalNum {
				font-size: 14px;
				color: #000;
			}
		}

		.cartHeight_cart {
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: #485577; /* 购物车结算按钮背景色修改 */
			color: white;
			font-size: 15px;

			a.router-link-exact-active.router-link-active {
				color: white;
			}
		}
	}

	.input-with-select {
		.el-input-group__append {
			border: 1px solid;
			height: 40px;

			#seekBtn {
				width: 78px;
				height: 40px;
				background-color: #485577; /* 搜索按钮背景色修改 */
				box-sizing: border-box;
				margin-right: -22px;
				border-radius: 0;

				/deep/.el-icon-search {
					color: #fff;
					position: relative;
					top: -4px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/topnav.vue